module.exports = __webpack_public_path__ + "img/CAL-IEC-voltage.54ff0a941a76e2f823786a42bb389c23.avif";